import React, { useState } from "react";
import { Auth } from "aws-amplify";
import { FaEye, FaEyeSlash } from 'react-icons/fa'


const CustomPasswordReset = (props) => {

  const [email, setEmail] = useState("");
  const [code, setCode] = useState(String(window?.location?.search.substring(6, 12)));
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [hideNewPassword, setHideNewPassword] = useState(true);
  const [hideConfirmPassword, setHideConfirmPassword] = useState(true);
  
  const textboxStyle = {
    borderRadius: "4px",
    height: "40px",
    borderWidth: "thin",
    marginTop: "5px",
    textIndent: "10px",
  };
  const submitButtonStyle = {
    borderRadius: "8px",
    height: "45px",
    borderWidth: "thin",
    backgroundColor: props?.color,
    border: "none",
    color: "white",
    cursor: 'pointer'
  };
  const resendButtonStyle = {
    padding: "20px",
    height: "20px",
    marginTop:"10px",
    borderWidth: "thin",
    backgroundColor: "white",
    border: "none",
    color: props?.color,
    cursor: 'pointer'
  };

  const handleResetPassword = async () => {
    try {
      if (!email || !code || !newPassword || !confirmPassword) {
        alert("All fields need to be filled");
      } else if (newPassword !== confirmPassword) {
        alert("Passwords don't match");
      } else {
        await Auth.forgotPasswordSubmit(email, code, newPassword);
        return window.location.assign(window?.location?.origin);
      }
    } catch (error) {
      console.log(error);
      alert(error?.message);
    }
  };

  const getTemporaryCode = async () => {
    try {
      if (email) {
        await Auth.forgotPassword(email);
        alert("Please check your email for the new code");
      } else {
        alert("Please enter your email");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div style={{ display: "grid", padding: "2em" }}>
      <label style={{ fontSize: "xx-large" }}>Reset Password</label>
      <br />
      <label htmlFor="email">Email</label>
      <input
        type="email"
        id="email"
        name="email"
        required
        style={textboxStyle}
        placeholder="Enter your Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <br />
      <label htmlFor="code">Code *</label>
      <input
        type="text"
        id="code"
        name="code"
        required
        style={textboxStyle}
        placeholder="Temporary Password"
        value={code}
        onChange={(e) => setCode(e.target.value)}
      />
      <br />
      <label htmlFor="newPassword">New Password</label>
      <div style={{ display: "flex" }}>
        <div style={{ width: "90%" }}>
          <input
            type={hideNewPassword ? "password" : "text"}
            id="newPassword"
            name="newPassword"
            required
            style={{
              borderStartStartRadius: "4px",
              borderEndStartRadius: "4px",
              height: "40px",
              borderWidth: "thin",
              marginTop: "5px",
              textIndent: "10px",
              width: "100%",
            }}
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            width: "10%",
          }}
        >
          <button
            style={{
              height: "40px",
              backgroundColor: "white",
              borderWidth: "thin",
              borderLeft: "none",
              borderStartEndRadius: "4px",
              borderEndEndRadius: "4px",
            }}
            type="button"
            id="showNewPasswordButton"
            onClick={() => setHideNewPassword(!hideNewPassword)}
          >
            {hideNewPassword ? <FaEyeSlash  style={{margin:'auto'}}/> : <FaEye  style={{margin:'auto'}}/>}
          </button>
        </div>
      </div>
      <br />
      <label htmlFor="confirmPassword">Confirm Password</label>
      <div style={{ display: "flex" }}>
        <div style={{ width: "90%" }}>
          <input
            type={hideConfirmPassword ? "password" : "text"}
            id="confirmPassword"
            name="confirmPassword"
            required
            style={{
              borderStartStartRadius: "4px",
              borderEndStartRadius: "4px",
              height: "40px",
              borderWidth: "thin",
              marginTop: "5px",
              textIndent: "10px",
              width: "100%",
            }}
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            width: "10%",
          }}
        >
          <button
            style={{
              height: "40px",
              backgroundColor: "white",
              borderWidth: "thin",
              borderLeft: "none",
              borderStartEndRadius: "4px",
              borderEndEndRadius: "4px",
            }}
            type="button"
            id="showConfirmPasswordButton"
            onClick={() => setHideConfirmPassword(!hideConfirmPassword)}
          >
            {hideConfirmPassword ? <FaEyeSlash style={{margin:'auto'}} /> : <FaEye style={{margin:'auto'}} />}
          </button>
        </div>
      </div>
      <br />
      <input
        type="submit"
        style={submitButtonStyle}
        onClick={() => handleResetPassword()}
      />

      <input
        type="button"
        value="Resend Temporary Password"
        style={resendButtonStyle}
        onClick={getTemporaryCode}
      />
    </div>
  );
};

export default CustomPasswordReset;
